var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockFilledWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "#0057FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9996,
    cy: 27.9996,
    r: 22.4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0013 4.66797C15.1446 4.66797 4.66797 15.1446 4.66797 28.0013C4.66797 40.858 15.1446 51.3346 28.0013 51.3346C40.858 51.3346 51.3346 40.858 51.3346 28.0013C51.3346 15.1446 40.858 4.66797 28.0013 4.66797ZM38.1513 36.3313C37.8246 36.8913 37.2413 37.1946 36.6346 37.1946C36.3313 37.1946 36.028 37.1246 35.748 36.938L28.5146 32.6213C26.718 31.548 25.388 29.1913 25.388 27.1146V17.548C25.388 16.5913 26.1813 15.798 27.138 15.798C28.0946 15.798 28.888 16.5913 28.888 17.548V27.1146C28.888 27.9546 29.588 29.1913 30.3113 29.6113L37.5446 33.928C38.3846 34.418 38.6646 35.4913 38.1513 36.3313Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFilledWhite);
export default __webpack_public_path__ + "static/media/ClockFilledWhite.6179457f57c5c9a63cbe9413bb3c388f.svg";
export { ForwardRef as ReactComponent };